import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createCarmensOwnDTLog = (payload) => post(baseURL + url.ARCHIVAL_DT_LOG, payload);
export const getCarmensOwnDTLogDetails = (id) => get(`${baseURL + url.ARCHIVAL_DT_LOG}/${id}`);
export const updateCarmensOwnDTLog = (id, payload) => put(`${baseURL + url.ARCHIVAL_DT_LOG}/${id}`, payload);
export const deleteCarmensOwnDTLog = (id) => remove(`${baseURL + url.ARCHIVAL_DT_LOG}/${id}`);
